const sizeStyles = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
} as const

type SpinnerSize = keyof typeof sizeStyles

interface SpinnerProps {
  size?: SpinnerSize
  className?: string
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  // `border-blue-500` in light mode, a brighter `border-blue-400` once the
  // `dark` class is applied, so the spinner stays visible against the darker
  // surface backgrounds. Both are close to the brand `op-blue` accent.
  const classes = [
    'animate-spin rounded-full border-b-2 border-blue-500 dark:border-blue-400',
    sizeStyles[size],
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return <div className={classes} role="status" aria-label="Loading" />
}
